import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Cargá los combustibles que despachás: gasoil de obra, gasoil premium, nafta.',
    'Separar los combustibles permite después analizar el consumo y el costo de cada uno por separado.',
    'Cada despacho se registra contra uno de estos tipos, así que conviene definirlos antes de operar.',
  ],
  nextSteps: [
    'Registrar los despachos de combustible indicando el tipo correspondiente.',
    'Consultar el informe de combustible para ver consumos y rendimientos por equipo.',
  ],
};

const ConfiguracionTiposCombustible = () => {
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');
  const backTo = from === 'config-combustible' ? '/configuracion?seccion=combustible' : '/combustible';

  return (
    <ConfiguracionBase
      apiEndpoint="tipos-combustible"
      titulo="Tipos de Combustible"
      descripcion="Combustibles despachables (gasoil, nafta, etc.)"
      icon="fas fa-gas-pump"
      compact
      backTo={backTo}
      help={HELP}
    />
  );
};

export default ConfiguracionTiposCombustible;
